import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import Popup from 'Components/Popup'
import React from 'react'
import styles from './styles'

const MessageSentPopup = ({ onClose, classes }) => {
  return (
    <Popup
      title="Message sent"
      onCancel={onClose}
      modalClassName={classes.submissionPopup}
      body={
        <div>
          <div className={classes.infoBlock}>
            <div className={classes.content}>
              Thank you we're received your message
            </div>
            <div className={classes.content}>
              We will review it as son as possible and contact you shortly.
            </div>
          </div>
        </div>
      }
      footer={
        <div>
          <Button
            className={cn(classes.button, classes.filledButton)}
            variant="outlined"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      }
    />
  )
}

export default withStyles(styles)(MessageSentPopup)
